import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card mb-6" }
const _hoisted_2 = { class: "grid ml-0" }
const _hoisted_3 = { class: "col-12 grid" }
const _hoisted_4 = { class: "flex flex-auto p-input-icon-left p-input-icon-right mt-1" }
const _hoisted_5 = { class: "col-12 grid text-right pt-1" }
const _hoisted_6 = { class: "flex mt-1 mr-4" }
const _hoisted_7 = { class: "flex mt-1 mr-4" }
const _hoisted_8 = { class: "flex mt-1 mr-4" }
const _hoisted_9 = { class: "flex mt-1 align-items-center" }
const _hoisted_10 = { class: "flex mt-1 align-items-center" }
const _hoisted_11 = {
  key: 0,
  class: "flex mt-1 align-items-center"
}
const _hoisted_12 = {
  key: 1,
  class: "flex mt-1 align-items-center"
}
const _hoisted_13 = { class: "col-12" }
const _hoisted_14 = { class: "grid flex-nowrap" }
const _hoisted_15 = {
  key: 0,
  class: "col-fixed hidden lg:block dateColumn pl-4"
}
const _hoisted_16 = {
  key: 1,
  class: "col-fixed hidden lg:block calendarColumnHeader"
}
const _hoisted_17 = {
  key: 2,
  class: "col-fixed hidden lg:block completedColumn"
}
const _hoisted_18 = { class: "grid flex-nowrap" }
const _hoisted_19 = { class: "col-fixed ml-1" }
const _hoisted_20 = { class: "col" }
const _hoisted_21 = { class: "col" }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { class: "col hidden lg:block" }
const _hoisted_24 = { class: "col-fixed hidden xl:block daysColumn" }
const _hoisted_25 = { class: "col-fixed hidden lg:block dateColumn" }
const _hoisted_26 = { class: "col-fixed hidden xl:block dateColumn" }
const _hoisted_27 = {
  key: 0,
  class: "col-fixed hidden lg:block dateColumn"
}
const _hoisted_28 = {
  key: 1,
  class: "col-fixed hidden lg:block calendarColumn my-1"
}
const _hoisted_29 = {
  key: 2,
  class: "col-fixed hidden lg:block my-1 completedColumn"
}
const _hoisted_30 = { class: "col-fixed hidden md:block infoColumn" }
const _hoisted_31 = ["onClick"]
const _hoisted_32 = { class: "grid" }
const _hoisted_33 = { class: "col-10" }
const _hoisted_34 = {
  key: 0,
  class: "col-2 label"
}
const _hoisted_35 = {
  key: 1,
  class: "col-10"
}
const _hoisted_36 = { class: "col-12 pre-wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_InputSwitch = _resolveComponent("InputSwitch")!
  const _component_Message = _resolveComponent("Message")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Badge = _resolveComponent("Badge")!
  const _component_Button = _resolveComponent("Button")!
  const _component_DataView = _resolveComponent("DataView")!
  const _component_Sidebar = _resolveComponent("Sidebar")!
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _cache[20] || (_cache[20] = _createElementVNode("i", { class: "pi pi-home" }, null, -1)),
            _createVNode(_component_InputText, {
              modelValue: _ctx.filterText,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filterText) = $event)),
              placeholder: "Property keyword filter..",
              onInput: _ctx.filterChanged
            }, null, 8, ["modelValue", "onInput"]),
            _cache[21] || (_cache[21] = _createElementVNode("i", { class: "pi pi-search" }, null, -1))
          ]),
          _withDirectives(_createElementVNode("a", {
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.dashboardExcelExport && _ctx.dashboardExcelExport(...args))),
            class: "css-image excel-icon mt-1"
          }, null, 512), [
            [
              _directive_tooltip,
              'Export to Excel',
              void 0,
              { top: true }
            ]
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_Dropdown, {
              modelValue: _ctx.selectedService,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedService) = $event)),
              options: _ctx.servicesList,
              optionLabel: "serviceName",
              placeholder: "Select service",
              filter: true,
              filterPlaceholder: "Find a service",
              class: "w-100pc",
              onChange: _ctx.search
            }, null, 8, ["modelValue", "options", "onChange"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_Calendar, {
              modelValue: _ctx.startDate,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.startDate) = $event)),
              class: "w-100pc",
              showIcon: true,
              dateFormat: "d M yy",
              placeholder: "Start date",
              showButtonBar: true
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_Calendar, {
              modelValue: _ctx.endDate,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.endDate) = $event)),
              class: "w-100pc",
              showIcon: true,
              dateFormat: "d M yy",
              placeholder: "End date",
              showButtonBar: true
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_InputSwitch, {
              modelValue: _ctx.activeProperty,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.activeProperty) = $event)),
              class: "mr-1",
              onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.search(true)))
            }, null, 8, ["modelValue"]),
            _createElementVNode("a", {
              class: "mr-4",
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.activeProperty=!_ctx.activeProperty))
            }, "Active properties only")
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_InputSwitch, {
              modelValue: _ctx.activeService,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.activeService) = $event)),
              class: "mr-1",
              onChange: _cache[9] || (_cache[9] = ($event: any) => (_ctx.search(true)))
            }, null, 8, ["modelValue"]),
            _createElementVNode("a", {
              class: "mr-4",
              onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.activeService=!_ctx.activeService))
            }, "Active services only")
          ]),
          (_ctx.isInternalUser && _ctx.selectedService.serviceId == _ctx.BwofServiceId)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createVNode(_component_InputSwitch, {
                  modelValue: _ctx.readyToIssue,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.readyToIssue) = $event)),
                  class: "mr-1",
                  onChange: _cache[12] || (_cache[12] = ($event: any) => (_ctx.search(true)))
                }, null, 8, ["modelValue"]),
                _createElementVNode("a", {
                  class: "mr-4",
                  onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.readyToIssue=!_ctx.readyToIssue))
                }, "Ready to issue")
              ]))
            : _createCommentVNode("", true),
          (_ctx.isInternalUser)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createVNode(_component_InputSwitch, {
                  modelValue: _ctx.includeBwofAnniversary,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.includeBwofAnniversary) = $event)),
                  class: "mr-1",
                  onChange: _cache[15] || (_cache[15] = ($event: any) => (_ctx.search(true)))
                }, null, 8, ["modelValue"]),
                _createElementVNode("a", {
                  class: "mr-4",
                  onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.includeBwofAnniversary=!_ctx.includeBwofAnniversary))
                }, "Include Bwof Anniversary")
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      (_ctx.searchError)
        ? (_openBlock(), _createBlock(_component_Message, {
            key: 0,
            severity: "error"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.searchError), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createElementVNode("div", null, [
        _createVNode(_component_DataView, {
          value: _ctx.dashboardListData,
          datakey: "propertyId",
          paginator: true,
          rows: 100,
          scrollable: true,
          stripedRows: "",
          class: "p-datatable-sm",
          paginatorTemplate: _ctx.paginatorTemplate,
          rowsPerPageOptions: [10,20,50,100,200],
          responsiveLayout: "scroll",
          alwaysShowPaginator: false,
          currentPageReportTemplate: "Showing {first} to {last} of {totalRecords}"
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _cache[22] || (_cache[22] = _createElementVNode("div", { class: "col-fixed" }, "ID", -1)),
                _cache[23] || (_cache[23] = _createElementVNode("div", { class: "col" }, "Property", -1)),
                _cache[24] || (_cache[24] = _createElementVNode("div", { class: "col" }, "Service", -1)),
                _cache[25] || (_cache[25] = _createElementVNode("div", { class: "col hidden lg:block" }, "Supplier", -1)),
                _cache[26] || (_cache[26] = _createElementVNode("div", { class: "col-fixed hidden xl:block daysColumn pl-3" }, "Due days", -1)),
                _cache[27] || (_cache[27] = _createElementVNode("div", { class: "col-fixed hidden lg:block dateColumn" }, "Due date", -1)),
                _cache[28] || (_cache[28] = _createElementVNode("div", { class: "col-fixed hidden xl:block dateColumn" }, "Previous date", -1)),
                (_ctx.includeBwofAnniversary)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, "Bwof anniversary"))
                  : _createCommentVNode("", true),
                (_ctx.displayCompletedHeader)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, "New previous date"))
                  : _createCommentVNode("", true),
                (_ctx.displayCompletedHeader)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, "Completed?"))
                  : _createCommentVNode("", true),
                _cache[29] || (_cache[29] = _createElementVNode("div", { class: "col-fixed hidden md:block infoColumn" }, null, -1))
              ])
            ])
          ]),
          list: _withCtx(({data}) => [
            _createElementVNode("div", {
              class: _normalizeClass(["col-12 property-dashboard-item hover-row", _ctx.rowStatus(data)])
            }, [
              _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _createVNode(_component_router_link, {
                    to: { name: 'PropertyDetails', params: { propertyId: data.propertyId }}
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(data.propertyId), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _createVNode(_component_router_link, {
                    to: { name: 'PropertyDetails', params: { propertyId: data.propertyId }}
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(data.propertyNameAndLocation), 1),
                      _cache[30] || (_cache[30] = _createElementVNode("br", null, null, -1)),
                      _createElementVNode("small", null, _toDisplayString(data.customerName), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"]),
                  (!data.propertyActive)
                    ? (_openBlock(), _createBlock(_component_Badge, {
                        key: 0,
                        class: "small-grey-badge ml-1",
                        value: "inactive"
                      }))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _createVNode(_component_router_link, {
                    to: { name: 'PropertyDetails', params: { propertyId: data.propertyId }}
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(data.serviceName) + " ", 1),
                      _cache[31] || (_cache[31] = _createElementVNode("br", null, null, -1)),
                      (_ctx.showBwofStatistics)
                        ? (_openBlock(), _createElementBlock("small", _hoisted_22, _toDisplayString(data.readyBwofSubServices) + " of " + _toDisplayString(data.totalBwofSubServices), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1032, ["to"]),
                  (!data.serviceActive)
                    ? (_openBlock(), _createBlock(_component_Badge, {
                        key: 0,
                        class: "small-grey-badge ml-1",
                        value: "inactive"
                      }))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_23, _toDisplayString(data.supplierName), 1),
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("span", null, _toDisplayString(data.days), 1)
                ]),
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.formattedDate(data.due)), 1)
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.formattedDate(data.lastDue)), 1)
                ]),
                (_ctx.includeBwofAnniversary)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.formattedDate(data.bwofDue)), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.displayUpdateAnniversaryCheckbox(data))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                      _createVNode(_component_Calendar, {
                        modelValue: data.newPreviousDate,
                        "onUpdate:modelValue": ($event: any) => ((data.newPreviousDate) = $event),
                        showIcon: true,
                        dateFormat: "d M yy"
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.displayUpdateAnniversaryCheckbox(data))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                      _createVNode(_component_Button, {
                        icon: "pi pi-check",
                        "aria-label": "Mark as Complete",
                        onClick: ($event: any) => (_ctx.handleComplete(data))
                      }, null, 8, ["onClick"])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("a", {
                    onClick: ($event: any) => (_ctx.clickSidebar(data))
                  }, [...(_cache[32] || (_cache[32] = [
                    _createElementVNode("i", { class: "pi pi-info-circle" }, null, -1)
                  ]))], 8, _hoisted_31)
                ])
              ])), [
                [
                  _directive_tooltip,
                  _ctx.getNotes(data),
                  void 0,
                  { bottom: true }
                ]
              ])
            ], 2)
          ]),
          _: 1
        }, 8, ["value", "paginatorTemplate"]),
        _createVNode(_component_Sidebar, {
          visible: _ctx.showSidebar,
          "onUpdate:visible": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.showSidebar) = $event)),
          baseZIndex: 1000,
          position: "right",
          class: "p-sidebar-md"
        }, {
          default: _withCtx(() => [
            _createElementVNode("h3", null, [
              _createElementVNode("a", {
                onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.click(_ctx.sidebarData)))
              }, _toDisplayString(_ctx.sidebarData.propertyName), 1)
            ]),
            _createElementVNode("div", _hoisted_32, [
              _cache[33] || (_cache[33] = _createElementVNode("div", { class: "col-2 label" }, " Address ", -1)),
              _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.sidebarData.streetAddress) + " " + _toDisplayString(_ctx.sidebarData.location), 1),
              (_ctx.isInternalUser)
                ? (_openBlock(), _createElementBlock("div", _hoisted_34, " Customer "))
                : _createCommentVNode("", true),
              (_ctx.isInternalUser)
                ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                    _createElementVNode("a", {
                      onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.customerClick(_ctx.sidebarData.custId)))
                    }, _toDisplayString(_ctx.sidebarData.customerName), 1)
                  ]))
                : _createCommentVNode("", true),
              _cache[34] || (_cache[34] = _createElementVNode("div", { class: "col-12 label" }, " Exception Notes ", -1)),
              _createElementVNode("div", _hoisted_36, [
                _createElementVNode("small", null, _toDisplayString(_ctx.sidebarData.exceptionNotes), 1)
              ])
            ])
          ]),
          _: 1
        }, 8, ["visible"])
      ])
    ]),
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_ProgressSpinner, { key: 0 }))
      : _createCommentVNode("", true)
  ], 64))
}